/* eslint-disable prettier/prettier */
/* eslint-disable no-debugger */
/* eslint-disable sonarjs/no-redundant-boolean */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable prefer-const */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';
import { useState, useEffect, useContext } from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  RACTextbox,
  RACModalCard,
  RACButton,
  RACCOLOR,
  CircularProgress,
} from '@rentacenter/racstrap';
import PaymentCostProps from './PaymentCostInterface';
import Modal from 'react-modal';
import { ReactComponent as RacLogo } from '../../assets/images/RAC-Logo.svg';
import SecondFactor from '../TwoFactorPopup/TwoFactorPopup';
import CurrencyInput from 'react-currency-input-field';
import { paymentCost } from '../../../JSstyles/paymentCost';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { AgreementContext } from '../../../context/AgreementContext';
import { FeatureFlagContext } from '../../../context/FeatureFlagContext';
import { GetRole, GetEmployeeID } from '../../../api/user';
import { ContainerContext } from '../../../app/App';
import { CustomPropInterface } from '../../../index';
import { useTranslation } from 'react-i18next';

export default function PaymentCost(props: any) {

  const { i18n, t } = useTranslation('rental');

  const containerData = useContext(ContainerContext) as CustomPropInterface;

  let { isSacDaysCompleted, 
    isReinstated,
    StoreExceptiontype,
    setStoreExceptiontype, 
    addedItem,
    rewardErrorMessage, 
    isMotorcycleAdded, 
    customerPromotions,
    customerTierDetails,
    SalesLeadPromo } = useContext(AgreementContext);
  const { sacRolesLimitDetails, featureFlagDetails } = useContext(FeatureFlagContext);
  const configDataObj = sacRolesLimitDetails



  // const configDataObj = {
  //   'FSC-CAR': 0,
  //   'CAR': 0,
  //   'FSC-AM': 60,
  //   'AM': 60,
  //   'FSC-LAM': 60,
  //   'LAM': 60,
  //   'FSC-SMT': 60,
  //   'SMT': 60,
  //   'FSC-SM': 60,
  //   'SM': 60,
  //   'FSC-SSM': 60,
  //   'SSM': 60,
  //   'FSC-DMT': 60,
  //   'DMT': 60,
  //   'FSC-DM': 60,
  //   'DM': 60,
  //   'FSC-RDT': 60,
  //   'RDT': 60,
  //   'FSC-RD': 60,
  //   'RD': 60
  // }
  const [configData, setConfigData] = useState(configDataObj);
  const classes = props.throwStyle;
  const paymentCostClassName = paymentCost();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [OtherTest, setOtherTest]: any = useState('0.00');


  //PS_AD-1 creating object to store total payment values
  const TotalpaymemtObj = {
    totalInitialPayment: '',
    regularPaymentsCount: '',
    regularPaymentsAmount: '',
    finalPayment: '',
    totalPaymentsCount: '',
    sacTotal: '',
    AgreementTotal: '',
  };
  //PS_AD-1 creating object to store initial payment values
  const InitialPaymentObj = {
    OtherAmt: '0.00',
    rate: '',
    Discount: '0.00',
    extensionAmount: '',
    policy: '',
    ldw: '',
    tax: '',
    discountAmount: '',
  };
  const tierPromotionsValue = props.tierPromotionsValue
  //PS_AD-1 creating state variable to hold TotalpaymemtObj
  const [TotalPayment, setTotalPayment]: any = useState(TotalpaymemtObj);
  //PS_AD-1 creating state variable to hold InitialPaymentObj
  const [IntPayment, setIntPayment] = useState(InitialPaymentObj);
  //PS_AD-1 creating state variable to store total Initial payment
  const [TotalIniPayment, setTotalIniPayment] = useState('');
  //PS_AD-1 creating state variable to store other input enable disable
  const [OtherDisable, setOtherDisable] =
    useState<PaymentCostProps['OtherDisable']>(false);
  const [SacDisable, setSacDisable] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [ProcessingFeeLimit, setProcessingFeeLimit] = useState('0.00');
  const [ProcessingFee, setProcessingFee] = useState('0.00');
  const [ProcessingFeePopupOpen, setProcessingFeePopupOpen] = useState(false);
  const [AuthenticationPopupOpen, setAuthenticationPopupOpen] = useState(false);
  const [ProcessingFeeErrorLbl, setProcessingFeeErrorLbl] = useState(false);
  const [TwoFactorCancelClick, setTwoFactorCancelClick] = useState(false);
  const [TwoFactorCompleted, setTwoFactorCompleted] = useState(false);
  const [moduleName, setmoduleName] = useState('Edit SAC Fee');
  const [SecondFactorOpen, setSecondFactorOpen] = useState(false);
  const [SecondFactorUsingField, setSecondFactorUsingField] = useState('');
  const [SACoriginalAmount, setSACoriginalAmount] = useState(0);
  const [SACallowedAmt, setSACallowedAmt] = useState('');
  const [SAClowerlimit, setSAClowerlimit] = useState(0);

  const [CurrentRole, setCurrentRole] = useState('')

  const [ExceedPopupOpen, setExceedPopupOpen] = useState(false);
  const [OverRidePopupOpen, setOverRidePopupOpen] = useState(false);
  const [OtherAmtWOproFee, setOtherAmtWOproFee]: any = useState();
  const [FeeArrWOProFee, setFeeArrWOProFee] = useState([]);
  const [RecalculateReq, setRecalculateReq] = useState({});
  const [roleFromSLAModule, setRoleFromSLAModule] = useState('');
  const [HiddenLoader, setHiddenLoader] = useState(false);
  const [SLAMinRole, setSLAMinRole] = useState('');
  const [rewardAmount, setRewardAmount] = useState('0.00');
  const [matchingPromotions, setMatchingPromotions] = React.useState<any>([]);


  useEffect(() => {
    const filteredPromotions = customerPromotions?.promotions?.filter((promotion) => {
      return promotion.promotionNumber == SalesLeadPromo ||
        promotion.promotionCode == SalesLeadPromo;
    }) || [];

    setMatchingPromotions(filteredPromotions);
    console.log(filteredPromotions, 'matchingPromotions');
  }, [customerPromotions, SalesLeadPromo]);


  useEffect(() => {
    const GettingRole = async () => {
      const GetcurrentUser = await GetEmployeeID();
      console.log('GetcurrentUser', GetcurrentUser);
      if (GetcurrentUser.status === 200) {
        const GetcurrentUserResponse = GetcurrentUser.data;
        const EmployeeId = GetcurrentUserResponse.employeeId;
        const GetMenuPayload = {
          coworkerId: EmployeeId,
        };
        const GetMenuDetails: any = await GetRole(GetMenuPayload);
        console.log('GetMenuDetails', GetMenuDetails);
        if (GetMenuDetails.status === 200) {
          const GetMenuDetailsResponse = GetMenuDetails.data;
          const currentRole = GetMenuDetailsResponse.coworkerProfile.role;
          console.log('currentRole', currentRole);
          setCurrentRole(currentRole);
        }
      }
    };
    if (containerData !== undefined) {
      console.log('containerData', containerData);
      console.log('containerDataRole', containerData.GetRole());
      setCurrentRole(containerData.GetRole());
    } else {
      GettingRole();
    }
  }, []);

  useEffect(() => {
    console.log('sacRolesLimitDetails', sacRolesLimitDetails);
    const InitialPaymentProps = props.InitialPaymentValues;
    const TotalPaymentProps = props.TotalPaymentValues;
    const OtherFeeArray = props.OtherFeeArray;
    const AgrementTotalProps = props.AgreementTotal;
    const RewardPromotionDetails = props.rewardPromotionDetails;
    if (InitialPaymentProps !== undefined) {
      props.setPaymentCostLoading(false);
      setIntPayment({
        ...IntPayment,
        OtherAmt: InitialPaymentProps.otherFees,
        rate: InitialPaymentProps.rate,
        extensionAmount: InitialPaymentProps.extensionAmount,
        ldw: InitialPaymentProps.ldw,
        tax: InitialPaymentProps.totalTax,
        policy: InitialPaymentProps.policy,
        discountAmount: InitialPaymentProps?.discountAmount
      });
      setTotalIniPayment(InitialPaymentProps.initialPayment);
      if (RewardPromotionDetails != undefined && featureFlagDetails.EnableRewardPromotion == '1')
        setRewardAmount(InitialPaymentProps?.rewardsAmountUsed);
    }
    if (TotalPaymentProps !== undefined && AgrementTotalProps !== undefined) {
      setTotalPayment({
        ...TotalPayment,
        totalInitialPayment: TotalPaymentProps.initialPaymentTotal,
        regularPaymentsCount: TotalPaymentProps.regularPaymentsCount,
        regularPaymentsAmount: TotalPaymentProps.regularPaymentsAmount,
        finalPayment: TotalPaymentProps.finalPayment,
        totalPaymentsCount: TotalPaymentProps.totalPaymentsCount,
        sacTotal:
          isSacDaysCompleted == '1'
            ? TotalPaymentProps.epoAmount
            : TotalPaymentProps.sacTotal,
        AgreementTotal: AgrementTotalProps,
      });
      setOtherDisable(true);
      setSACoriginalAmount(
        parseFloat(
          isSacDaysCompleted == '1'
            ? TotalPaymentProps.epoAmount
            : TotalPaymentProps.sacTotal
        )
      );
      setSACallowedAmt(TotalPaymentProps.sacTotal);
    }
    if (OtherFeeArray != undefined) {
      if (OtherFeeArray.length > 0) {
        const TempOtherArr = OtherFeeArray.filter((e) => e.feeType == 'PROC');
        if (TempOtherArr.length > 0) {
          setOtherDisable(false);
          setProcessingFeeLimit(TempOtherArr[0].originalFeeAmount);
          setProcessingFee(TempOtherArr[0].feeAmount.toFixed(2));
        }
        const TempOtherFilterArr = OtherFeeArray.filter(
          (e) => e.feeType != 'PROC'
        );
        setFeeArrWOProFee(TempOtherFilterArr);
        let TempAmt = 0;
        for (let i = 0; i <= TempOtherFilterArr.length - 1; i++) {
          TempAmt = TempAmt + TempOtherFilterArr[i].feeAmount;
        }
        setOtherAmtWOproFee(TempAmt);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.ExtAmt,
    props.InitialPaymentValues,
    props.TotalPaymentValues,
    props.OtherFeeArray,
    props.AgreementTotal,
    props.rewardPromotionDetails,
    props.PaymentCostLoading
  ]);

  useEffect(() => {
    if (TwoFactorCancelClick === true && SecondFactorUsingField === 'SAC') {
      console.log('Inside completed false', SACallowedAmt);
      setSecondFactorOpen(false);
      setTotalPayment({
        ...TotalPayment,
        sacTotal: SACallowedAmt,
      });
    } else if (
      TwoFactorCompleted === true &&
      SecondFactorUsingField === 'SAC'
    ) {
      StoreExceptiontype = { ...StoreExceptiontype, sacPriceEdited: true }
      setStoreExceptiontype(StoreExceptiontype)
      setSecondFactorOpen(false);
      const obj = {
        sacPrice: parseFloat(TotalPayment.sacTotal),
      };
      props.SacChanged(obj);
      // roleAndLimitValidation(roleFromSLAModule);
    }
    if (
      TwoFactorCancelClick === true &&
      SecondFactorUsingField === 'OtherAmt'
    ) {
      setSecondFactorOpen(false);
      setProcessingFeePopupOpen(false);
    } else if (
      TwoFactorCompleted === true &&
      SecondFactorUsingField === 'OtherAmt'
    ) {
      setSecondFactorOpen(false);
      setProcessingFeePopupOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TwoFactorCancelClick, TwoFactorCompleted]);
  const roleAndLimitValidation = async (employeeId: any) => {
    let roleForAction = '';
    if (employeeId) {
      setHiddenLoader(true);
      const GetRolePayload = {
        coworkerId: employeeId,
      };
      const GetMenuDetails: any = await GetRole(GetRolePayload);
      setHiddenLoader(false);
      if (GetMenuDetails.status === 200) {
        const GetMenuDetailsResponse = GetMenuDetails.data;
        roleForAction = GetMenuDetailsResponse.coworkerProfile.role;
      }
    } else {
      roleForAction = props.CurrentRole;
    }
    debugger
    const allowedLimit = makeSAClimitcheck(roleForAction);
    if (Number(TotalPayment.sacTotal) < allowedLimit) {
      setTotalPayment({
        ...TotalPayment,
        sacTotal: SACallowedAmt,
      });
      setOverRidePopupOpen(true);
    } else {
      const obj = {
        sacPrice: parseFloat(TotalPayment.sacTotal),
      };
      props.SacChanged(obj);
    }
  };
  const makeSAClimitcheck = (role: any) => {
    debugger
    if (sacRolesLimitDetails[role]) {
      const multiplier = Number(sacRolesLimitDetails[role]) / 100;
      const newLimit: any =
        Number(SACoriginalAmount) - Number(SACoriginalAmount) * multiplier;
      return newLimit;
    }
  };

  const OtherAmountOnclick = () => {
    setSecondFactorUsingField('OtherAmt');
    setTwoFactorCompleted(false);
    setSecondFactorOpen(true);
  };
  const OtherAmtOnblurClick = (e: any) => {
    try {
      const InputTxt = e.target.value;
      let InputTxtArr = InputTxt.split('');
      if (InputTxtArr.includes(',') === true) {
        InputTxtArr = InputTxtArr.filter((element: any) => element != ',');
        let TempString = '';
        for (let i = 0; i <= InputTxtArr.length - 1; i++) {
          TempString = TempString + InputTxtArr[i];
        }
        const FloatInputTxt = parseFloat(TempString);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setOtherTest(ResultInputTxt);
        setIntPayment({ ...IntPayment, OtherAmt: ResultInputTxt });
      } else if (InputTxt === '.' || InputTxt === '') {
        setOtherTest('0.00');
        setIntPayment({ ...IntPayment, OtherAmt: '0.00' });
      } else {
        const FloatInputTxt = parseFloat(InputTxt);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setOtherTest(ResultInputTxt);
        setIntPayment({ ...IntPayment, OtherAmt: ResultInputTxt });
      }
    } catch {
      throw Error;
    }
  };
  const AuthentivcationLoginClcik = () => {
    try {
      setAuthenticationPopupOpen(false);
      setProcessingFeePopupOpen(true);
    } catch {
      throw Error;
    }
  };
  const ProcessingFeeOnClick = (e: any) => {
    try {
      const InputTxt = e.target;
      InputTxt.select();
    } catch {
      throw Error;
    }
  };
  const ProcessingFeeOnchange = (value: any) => {
    try {
      const TempTxt = parseFloat(value);
      if (TempTxt >= 0.00 && TempTxt <= 999.0) {
        setProcessingFee(value);
      }
      if (value == undefined || value === '') {
        setProcessingFee('');
      }
    } catch {
      throw Error;
    }
  };
  const ProcessingFeeOnBlurClick = (e: any) => {
    try {
      const InputTxt = e.target.value;
      let InputTxtArr = InputTxt.split('');
      if (InputTxtArr.includes(',') === true) {
        InputTxtArr = InputTxtArr.filter((element: any) => element !== ',');
        let TempString = '';
        for (let i = 0; i <= InputTxtArr.length - 1; i++) {
          TempString = TempString + InputTxtArr[i];
        }
        const FloatInputTxt = parseFloat(TempString);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setProcessingFee(ResultInputTxt);
      } else if (InputTxt === '.' || InputTxt === '' || InputTxt == '-') {
        setOtherTest('0.00');
        setProcessingFee('');
        setIntPayment({ ...IntPayment, OtherAmt: '0.00' });
      } else {
        const FloatInputTxt = parseFloat(InputTxt);
        const ResultInputTxt = FloatInputTxt.toFixed(2);
        setProcessingFee(ResultInputTxt);
      }
    } catch {
      throw Error;
    }
  };

  const OverRideAmoutClick = () => {
    try {
      const InputProcessingFeeAmt = parseFloat(ProcessingFee);
      const ProcessingFeeScale = parseFloat(ProcessingFeeLimit);
      const Recalculatereqobj: any = RecalculateReq;
      if (InputProcessingFeeAmt <= ProcessingFeeScale) {
        const TempReq: any = FeeArrWOProFee;
        setProcessingFeeErrorLbl(false);
        setProcessingFeePopupOpen(false);
        const Obj = {
          feeType: 'PROC',
          feeAmount: ProcessingFee,
        };
        if (TempReq.filter((e) => e.feeType === 'PROC').length > 0) {
          const indexOfDuplicate = TempReq.findIndex(
            (arr) => arr.feeType === Obj.feeType
          );
          TempReq[indexOfDuplicate] = Obj;
        } else {
          TempReq.push(Obj);
        }
        console.log('Regenerated fee arr', TempReq);
        props.OtherAmtChanged(TempReq);
        Recalculatereqobj.processingFee = ProcessingFee;
        props.RecalculateClicked(Recalculatereqobj);
        setRecalculateReq(Recalculatereqobj);
      } else {
        setProcessingFeeErrorLbl(true);
      }
    } catch {
      throw Error;
    }
  };

  const SacAmountChange = (value: any) => {
    setSecondFactorOpen(false);
    setTotalPayment({ ...TotalPayment, sacTotal: value });
  };
  const SAConblurClick = (): any => {
    debugger

    const values = Object.values(configDataObj);
    const numericValues = values.filter((value): value is number => typeof value === 'number');
    const maxPercentageEdit = Math.max(...numericValues);

    const editedPercentage = Math.abs(
      ((SACoriginalAmount - TotalPayment.sacTotal) * 100) / SACoriginalAmount
    );
    if (SACoriginalAmount < Number(TotalPayment.sacTotal)) {
      debugger
      setExceedPopupOpen(true);
      setTotalPayment({
        ...TotalPayment,
        sacTotal: SACallowedAmt,
      });
    }
    else if (maxPercentageEdit < editedPercentage) {
      setOverRidePopupOpen(true)
      setTotalPayment({
        ...TotalPayment,
        sacTotal: SACallowedAmt,
      });
    }
    else if (Number(TotalPayment.sacTotal) != Number(SACoriginalAmount)) {
      debugger
      const percentCalculationInBlur = Math.abs(
        ((SACoriginalAmount - TotalPayment.sacTotal) * 100) / SACoriginalAmount
      );
      let minRole = '';
      let needSLA: any = false
      let output;
      const Roles = [
        'FSC-CAR',
        'CAR',
        'FSC-AM',
        'AM',
        'FSC-LAM',
        'LAM',
        'FSC-SMT',
        'SMT',
        'FSC-SM',
        'SM',
        'FSC-SSM',
        'SSM',
        'FSC-DMT',
        'DMT',
        'FSC-DM',
        'DM',
        'FSC-RDT',
        'RDT',
        'FSC-RD',
        'RD'
      ];
      for (const item in configDataObj) {
        debugger
        console.log('item in configDataObj', configData[item]);
        console.log('percentCalculation', Math.round(percentCalculationInBlur));
        if (
          configData[item] == Number(percentCalculationInBlur) &&
          Number(percentCalculationInBlur) !== 0
        ) {
          debugger
          console.log('correct item in configDataObj', configData[item]);
          console.log('correct percentCalculation', Math.round(percentCalculationInBlur));
          minRole = item;
          output = item;
          setSLAMinRole(minRole);
          // isFSC_Contain = minRole.includes('FSC');
          // if (isFSC_Contain) {
          //   output=minRole
          //   output = [minRole.slice(0, 3), '-', minRole.slice(3)].join('');
          //   setSLAMinRole(output);
          // } else {

          // }

          console.log('CurrentRole in Variable', CurrentRole);
          console.log(
            'Roles.indexOf(String(CurrentRole))',
            Roles.indexOf(String(CurrentRole))
          );
          console.log('Roles.indexOf(output)', Roles.indexOf(output));
          console.log('the output role', output);
          if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
            needSLA = true
            setSecondFactorUsingField('SAC');
            setSecondFactorOpen(true);
            setTwoFactorCancelClick(false);
            setTwoFactorCompleted(false);
          }
          // break;
          break;
        } else if (configData[item] > Number(percentCalculationInBlur)) {
          debugger
          console.log('correct item in configDataObj', configData[item]);
          console.log('correct percentCalculation', Math.round(percentCalculationInBlur));
          minRole = item;
          output = item;
          setSLAMinRole(minRole);
          // isFSC_Contain = minRole.includes('FSC');
          // if (isFSC_Contain) {
          //   output = [minRole.slice(0, 3), '-', minRole.slice(3)].join('');
          //   setSLAMinRole(output);
          // } else {
          //   output = item;
          //   setSLAMinRole(minRole);
          // }

          if (Roles.indexOf(String(CurrentRole)) < Roles.indexOf(item)) {
            needSLA = true
            setSecondFactorUsingField('SAC');
            setSecondFactorOpen(true);
            setTwoFactorCancelClick(false);
            setTwoFactorCompleted(false);
          }
          break;
        }
      }
      debugger
      if (needSLA == false) {
        setSLAMinRole('')
        setSecondFactorUsingField('SAC');
        setSecondFactorOpen(true);
        setTwoFactorCancelClick(false);
        setTwoFactorCompleted(false);
      }

      console.log('logged roles', CurrentRole);


    } else {
      setTotalPayment({
        ...TotalPayment,
        sacTotal: SACallowedAmt,
      });
    }
  };
  console.log(featureFlagDetails?.EnableCustomerTierReward == '1', tierPromotionsValue?.promoEngineResponse , tierPromotionsValue?.promotionNumber, "heyhey");
  
  const MoneyConvertion = (value) => {
    let convertedtext = '';
    const InputTxt = value;
    let InputTxtArr = InputTxt.split('');
    if (InputTxtArr.includes(',') === true) {
      InputTxtArr = InputTxtArr.filter((element: any) => element != ',');
      let TempString = '';
      for (let i = 0; i <= InputTxtArr.length - 1; i++) {
        TempString = TempString + InputTxtArr[i];
      }
      const FloatInputTxt = parseFloat(TempString);
      convertedtext = FloatInputTxt.toFixed(2);
    } else if (InputTxt === '.' || InputTxt === '') {
      convertedtext = '0.00';
    } else {
      const FloatInputTxt = parseFloat(InputTxt);
      convertedtext = FloatInputTxt.toFixed(2);
    }
    return convertedtext;
  };
  function formatMoney(Money: any) {
    console.log('Money', Money);
    if (Money !== undefined && typeof Money === 'string') {
      let MoneyFormat = Money.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (MoneyFormat === '0') {
        MoneyFormat = `${MoneyFormat}.00`;
      }
      return MoneyFormat;
    }
  }
  const HideLoader = () => {
    return (
      <Grid
        style={{
          position: 'fixed',
          background: '#f7f5f5',
          width: '100%',
          height: '100%',
          top: 0,
          left: 0,
          opacity: 0.6,
          zIndex: 2000,
          textAlign: 'center',
          margin: '0px 0px',
        }}
      >
        <Grid
          style={{
            display: 'block',
            position: 'fixed',
            zIndex: 9999999,
            top: '40%',
            right: '50%',
          }}
        >
          <CircularProgress />
        </Grid>
      </Grid>
    );
  };
  const ExceedPopup = () => {
    return (
      <div
        className=""
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography
            className={`${classes.semiBold} ${paymentCostClassName.formLabel}`}
          >
            {' '}
            {t("Cash price cannot exceed original price")}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter} `}
        >
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
            onClick={() => setExceedPopupOpen(false)}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const OverRidePopup = () => {
    return (
      <div
        className=""
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Typography
            className={`${classes.semiBold} ${paymentCostClassName.formLabel}`}
          >
            {' '}
            {t("Amount override cannot exceed the limit allowed")}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter} `}
        >
          <RACButton
            variant="contained"
            color="primary"
            className={classes.mx1}
            onClick={() => setOverRidePopupOpen(false)}
          >
            {t("ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const ProcessingFeePopup = () => {
    return (
      <div
        id="ProcessingFee"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid container className={`${classes.mb2} ${classes.mt2}`}>
          <Grid item md={6} className={classes.floatLeft}>
            <Typography
              variant="subtitle1"
              className={paymentCostClassName.cardLabel}
            >
              {t("Processing Fee Amount")}
            </Typography>
          </Grid>
          <Grid item md={6}>
            <Grid className={classes.floatRight}>
              <Typography
                className={`${paymentCostClassName.inputGroupText} ${classes.floatLeft}`}
              >
                $
              </Typography>
              <CurrencyInput
                id="input-example"
                name=""
                style={{ zIndex: 0, textAlign: 'right' }}
                className={
                  OtherDisable
                    ? `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} ${paymentCostClassName.disabledColour}`
                    : `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput}`
                }
                decimalsLimit={2}
                data-testid="ProcessingFeeTxtBoxTest"
                value={ProcessingFee}
                onBlur={(e) => ProcessingFeeOnBlurClick(e)}
                onClick={(e) => ProcessingFeeOnClick(e)}
                onValueChange={(value) => ProcessingFeeOnchange(value)}
              />
            </Grid>
          </Grid>
        </Grid>
        <label
          style={{
            color: 'red',
            fontSize: 'small',
            marginLeft: '15%',

            visibility: ProcessingFeeErrorLbl === false ? 'hidden' : 'visible',
          }}
          data-testid="OverRideErrorMsgTest"
        >
          {t("Please enter a valid processing fee amount less than $")}
          {`${ProcessingFeeLimit}`}
        </label>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => OverRideAmoutClick()}
          >
            {t("Override Amount")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  return (
    <div>
      {/* second level authentication popup starts here */}
      {HiddenLoader === true ? <HideLoader /> : null}
      {SecondFactorOpen === true ? (
        <SecondFactor
          setTwoFactorCancelClick={setTwoFactorCancelClick}
          setTwoFactorCompleted={setTwoFactorCompleted}
          moduleName={moduleName}
          currentRole={CurrentRole}
          setRoleFromSLAModule={setRoleFromSLAModule}
          minRole={SLAMinRole}

        />
      ) : null}

      {/* Processing fee popup ends here */}
      <RACModalCard
        isOpen={ProcessingFeePopupOpen}
        closeIcon={false}
        maxWidth="sm"
        borderRadius={'25px !important'}
      >
        {ProcessingFeePopup()}
      </RACModalCard>

      <RACModalCard
        isOpen={ExceedPopupOpen}
        maxWidth="xs"
        borderRadius={'25px !important'}
      >
        {ExceedPopup()}
      </RACModalCard>
      <RACModalCard
        isOpen={OverRidePopupOpen}
        maxWidth="xs"
        borderRadius={'25px !important'}
      >
        {OverRidePopup()}
      </RACModalCard>

      <Grid container className={classes.mb6}>
        <Grid item className={paymentCostClassName.paymentWidget}>
          <Grid container spacing={3}>
            <Grid item md={6}>
              <Typography className={classes.title}>{t("Initial Payment")}</Typography>

              <Card className={classes.card}>
                <CardContent className={classes.p32}>
                  <Grid container className={`${classes.mb2} ${classes.mt2}`}>
                    <Grid item md={6} className={classes.floatLeft}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.cardLabel}
                      >
                        {t("Other")}
                      </Typography>
                    </Grid>
                    <Grid item md={6}>
                      <Grid className={classes.floatRight}>
                        <Typography
                          className={`${paymentCostClassName.inputGroupText} ${classes.floatLeft}`}
                        >
                          $
                        </Typography>
                        <CurrencyInput
                          id="input-example"
                          name=""
                          style={{ zIndex: 0, textAlign: 'right' }}
                          className={
                            props.EditDisablemode || OtherDisable
                              ? `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} ${paymentCostClassName.disabledColour}`
                              : `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput}`
                          }
                          decimalsLimit={2}
                          data-testid="ProcessingFeeTxtBoxTest"
                          value={IntPayment.OtherAmt}
                          onBlur={(e) => OtherAmtOnblurClick(e)}
                          onClick={() => OtherAmountOnclick()}
                          disabled={props.EditDisablemode || OtherDisable}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.cardLabel}
                      >
                        {t("Rate")}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          $ {formatMoney(IntPayment.rate)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor="#FFFFFF"
                            highlightColor="#e7e7e7"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                  {console.log('featureFlagDetails- props.rewardPromotionDetails', props.rewardPromotionDetails, featureFlagDetails?.EnableRewardPromotion)}
                  {featureFlagDetails?.EnableRewardPromotion == '1' && Number(rewardAmount) > 0 && rewardErrorMessage?.isSuccessMsg != '' && <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.cardLabel}
                      >
                        {t("RAC Rewards")}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          -$ {formatMoney(rewardAmount)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor="#FFFFFF"
                            highlightColor="#e7e7e7"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>}

                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.cardLabel}
                      >
                        {t("Discount")}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          $ {formatMoney(IntPayment.Discount)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor="#FFFFFF"
                            highlightColor="#e7e7e7"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.cardLabel}
                      >
                        {t("Extension Amount")}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography>
                          {IntPayment.extensionAmount === '0.00' ? (
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.widgetAlign}
                            >
                              $ {formatMoney(IntPayment.extensionAmount)}
                            </Typography>
                          ) : (
                            <Typography
                              variant="subtitle1"
                              className={paymentCostClassName.widgetAlign}
                            >
                              ($ {formatMoney(IntPayment.extensionAmount)})
                            </Typography>
                          )}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor="#FFFFFF"
                            highlightColor="#e7e7e7"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>

                  {props.PolicyEnabled === true ? (
                    <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                      <Grid item md={7}>
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.cardLabel}
                        >
                          {t("Policy")}
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        {!props.PaymentCostLoading ? (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.widgetAlign}
                          >
                            $ {formatMoney(IntPayment.policy)}
                          </Typography>
                        ) : (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.widgetAlign}
                          >
                            <Skeleton
                              count={1}
                              baseColor="#FFFFFF"
                              highlightColor="#e7e7e7"
                            />
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  ) : null}
                  {!(featureFlagDetails.MXStoreIdentifier === "1" && isMotorcycleAdded) && (
                    <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                      <Grid item md={7}>
                        <Typography variant="subtitle1" className={paymentCostClassName.cardLabel}>
                          {t("LDW")}
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        {!props.PaymentCostLoading ? (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.widgetAlign}
                          >
                            $ {formatMoney(IntPayment.ldw)}
                          </Typography>
                        ) : (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.widgetAlign}
                          >
                            <Skeleton
                              count={1}
                              baseColor="#FFFFFF"
                              highlightColor="#e7e7e7"
                            />
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  )}

                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.cardLabel}
                      >
                        {t("Tax")}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          $ {formatMoney(IntPayment.tax)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.widgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor="#FFFFFF"
                            highlightColor="#e7e7e7"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    className={`${classes.mb2} ${classes.pt2} ${paymentCostClassName.payscheduleBorder} ${paymentCostClassName.alignCenter} ${classes.mt4}`}
                  >
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={`${classes.font18} ${classes.semiBold}`}
                      >
                        {t("Initial Payment")}{' '}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={`${classes.font24} ${classes.bold} ${classes.textRight}`}
                        >
                          $ {formatMoney(TotalIniPayment)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={`${classes.font24} ${classes.bold} ${classes.textRight}`}
                        >
                          <Skeleton
                            count={1}
                            baseColor="#FFFFFF"
                            highlightColor="#e7e7e7"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item md={6}>
              <Typography className={classes.title}>
                {t("Total Payment/Total Cost")}
              </Typography>

              <Card className={paymentCostClassName.bluecard}>
                <CardContent className={classes.p4}>
                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.blueCardLabel}
                      >
                        {t("Initial Payment")}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueWidgetAlign}
                        >
                          $ {formatMoney(TotalPayment.totalInitialPayment)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueWidgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor={RACCOLOR.NORMAL_BLUE}
                            highlightColor="#FFFFFF"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>

                  {props?.exchangeProps?.isExchangeAgreeement ? <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={9}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.blueCardLabel}
                      >
                        {t("Exchange Agreement Reduction")}
                      </Typography>
                    </Grid>
                    <Grid item md={3}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.blueWidgetAlign}
                      >
                        (${props?.exchangeProps?.exchangeAgreementRentPaid})
                      </Typography>
                    </Grid>
                  </Grid> : null}
                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={9}>
                      {!props.PaymentCostLoading ? (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.blueCardLabel}
                          >
                            {t("Regular Payments")} ({TotalPayment.regularPaymentsCount})
                          </Typography>
                          {
                            props?.exchangeProps?.isExchangeAgreeement ?
                              <Typography style={{ textDecoration: 'line-through', textDecorationColor: 'red', color: 'white', marginTop: '5px' }}>
                                $ {addedItem?.agreementPricing?.agreementTotal ? (parseFloat(addedItem?.agreementPricing?.agreementTotal) - parseFloat(TotalPayment?.totalInitialPayment) - parseFloat(TotalPayment?.finalPayment))?.toFixed(2) : 0.00}
                              </Typography> : null
                          }
                        </div>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueCardLabel}
                        >
                          {t("Regular Payments")}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item md={3}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueWidgetAlign}
                        >
                          $ {formatMoney(TotalPayment.regularPaymentsAmount)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueWidgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor={RACCOLOR.NORMAL_BLUE}
                            highlightColor="#FFFFFF"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>

                  {featureFlagDetails?.EnableCustomerTierReward == '1' && (tierPromotionsValue?.promotionCode || tierPromotionsValue?.promotionNumber) &&
                    <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                      <Grid item md={7}>
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueCardLabel}
                        >
                          {matchingPromotions[0]?.promotionCode}
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        {!props.PaymentCostLoading ? (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.blueWidgetAlign}
                          >
                            - $ {formatMoney(IntPayment?.discountAmount)}
                          </Typography>
                        ) : (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.blueWidgetAlign}
                          >
                            <Skeleton
                              count={1}
                              baseColor={RACCOLOR.NORMAL_BLUE}
                              highlightColor="#FFFFFF"
                            />
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  }

                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={7}>
                      <Typography
                        variant="subtitle1"
                        className={paymentCostClassName.blueCardLabel}
                      >
                        {t("Final Payment")}
                      </Typography>
                    </Grid>
                    <Grid item md={5}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueWidgetAlign}
                        >
                          $ {formatMoney(TotalPayment.finalPayment)}
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueWidgetAlign}
                        >
                          <Skeleton
                            count={1}
                            baseColor={RACCOLOR.NORMAL_BLUE}
                            highlightColor="#FFFFFF"
                          />
                        </Typography>
                      )}
                    </Grid>
                  </Grid>

                  <Grid container className={`${classes.mb2} ${classes.mt4}`}>
                    <Grid item md={12}>
                      {!props.PaymentCostLoading ? (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueCardLabel}
                        >
                          {' '}
                          {t("Total Payments")} ({TotalPayment.totalPaymentsCount})
                        </Typography>
                      ) : (
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.blueCardLabel}
                        >
                          {' '}
                          {t("Total Payments")}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>

                  <Card
                    className={`${classes.card} ${classes.p3} ${paymentCostClassName.mtcustom} ${paymentCostClassName.totalPaymentShade}`}
                  >
                    <Grid container className={classes.mb2}>
                      <Grid item md={7} className={classes.floatLeft}>
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.totalValue}
                        >
                          {isSacDaysCompleted == '1' && isReinstated == '1' || featureFlagDetails.MXStoreIdentifier == '1'
                            ? t('EPO Amount')
                            : t('Same As Cash Total')}
                        </Typography>
                      </Grid>

                      <Grid item md={5}>
                        <Grid className={classes.floatRight}>
                          <Typography
                            className={`${paymentCostClassName.inputGroupText} ${classes.floatLeft}`}
                          >
                            $
                          </Typography>
                          <CurrencyInput
                            id="input-example"
                            name=""
                            style={{ zIndex: 0, textAlign: 'right' }}
                            className={
                              props.EditDisablemode || SacDisable || props?.exchangeProps?.isExchangeAgreeement
                                ? `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput} ${paymentCostClassName.disabledColour}`
                                : `${paymentCostClassName.formControl} ${paymentCostClassName.currencyInput}`
                            }
                            decimalsLimit={2}
                            data-testid="ProcessingFeeTxtBoxTest"
                            value={featureFlagDetails.MXStoreIdentifier == '1' ? addedItem?.agreementPricing?.epoAmount : TotalPayment.sacTotal ? TotalPayment.sacTotal : 0}
                            onValueChange={(value) => SacAmountChange(value)}
                            onBlur={() => SAConblurClick()}
                            disabled={props.EditDisablemode || SacDisable || props?.exchangeProps?.isExchangeAgreeement || featureFlagDetails.MXStoreIdentifier == '1'}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      className={paymentCostClassName.alignCenter}
                    >
                      <Grid item md={7}>
                        <Typography
                          variant="subtitle1"
                          className={paymentCostClassName.totalValue}
                        >
                          {t("Agreement Total")}
                        </Typography>
                      </Grid>
                      <Grid item md={5}>
                        {!props.PaymentCostLoading ? (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.agreementTotal}
                          >
                            $ {formatMoney(TotalPayment.AgreementTotal)}
                          </Typography>
                        ) : (
                          <Typography
                            variant="subtitle1"
                            className={paymentCostClassName.agreementTotal}
                          >
                            <Skeleton
                              count={1}
                              baseColor="#FFFFFF"
                              highlightColor="#e7e7e7"
                            />
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Card>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
